import { IOperationalCostModel, IOperationalCostsCollection } from 'features/OperationalCosts/types'
import { OperationalCost } from 'gql/generated/graphql'
import { getStateByStateCode } from 'utils/states'

export const createOperationalCostsCollection = (items: OperationalCost[]): IOperationalCostsCollection => {
  return {
    items: items.map((item) => createOperationalCostModel(item)),
    isEmpty: items.length === 0
  }
}

export const getDurationFactor = ({
  duration,
  start,
  end
}: {
  duration: { start: number; end: number; factor: number }[]
  start: number
  end: number
}): number => {
  const durationFactor = duration.find((d) => d.start === start && d.end === end)
  return durationFactor ? durationFactor.factor : 0
}

export const createOperationalCostModel = (data: OperationalCost): IOperationalCostModel => {
  const { costs, factors } = data.settings || {}
  const durationFactors =
    factors.duration.map((duration) => ({
      start: duration.start,
      end: duration.end,
      factor: duration.value
    })) || []
  return {
    id: data.id || '',
    state: getStateByStateCode(data.stateCode) || {
      name: '',
      code: ''
    },
    vehicleCapacity: data.vehicleCapacity || 0,
    vehicleType: data.vehicleType || '',
    settings: {
      costs: {
        fixedCost: costs.fixedCost || 0,
        durationCost: costs.durationCost || 0,
        costPerKm: costs.costPerKm || 0,
        costPerDriver: costs.costPerDriver || 0
      },
      factors: {
        airConditioning: factors.airConditioning || 0,
        baseDistance: factors.baseDistance || 0,
        perKm: factors.perKm || 0,
        redZone: factors.redZone || 0,
        duration: durationFactors,
        durationFactor0to4: getDurationFactor({
          duration: durationFactors,
          start: 0,
          end: 4
        }),
        durationFactor5to8: getDurationFactor({
          duration: durationFactors,
          start: 5,
          end: 8
        }),
        durationFactor9to12: getDurationFactor({
          duration: durationFactors,
          start: 9,
          end: 12
        }),
        durationFactor13to16: getDurationFactor({
          duration: durationFactors,
          start: 13,
          end: 16
        }),
        durationFactor17to24: getDurationFactor({
          duration: durationFactors,
          start: 17,
          end: 24
        })
      }
    },
    businessClient: data.businessClient || null,
    businessSite: data.businessSite || null,
    createdAt: new Date(data.createdAt)
  }
}
